import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Equipment } from 'app/models2/maintenance/equipment';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  HttpService,
  MenuBreadCrumb,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { ModalCalendarComponent } from '../modal-calendar/modal-calendar.component';
import { Projection } from 'app/models2/maintenance/projection';
import { CalendarEvent } from 'angular-calendar';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-scheduled',
  templateUrl: './scheduled.component.html',
  styleUrls: ['./scheduled.component.scss'],
})
export class ScheduledComponent implements OnInit {


  recargarTablaProyeccionesOdometro: EventEmitter<any> =
    new EventEmitter<any>();
  public dataProyeccionesOdometro = []
  public configurationProyeccionesOdometro: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false
  }
  public columnasProyeccionesOdometro: Array<TableColumns<Projection>> = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'odometerFrequency',
      label: 'Frecuencia',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'odometerLastMtto',
      label: 'Odómetro/Horómetro ultimo mantenimiento',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'currentOdometer',
      label: 'Odómetro/Horómetro actual',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'odometerNextMtto',
      label: 'Odómetro/Horómetro próximo mantenimiento',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'remainingOdometer',
      label: 'Restante',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    }
  ]

  public rango: number = 10000

  public comboEquipos: Array<Equipment>;

  private urlComboEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`;
  public urlGetTablaProyeccionesOdometro: string = `${EndpointDictionary.OdometerProjection.ODOMETER_PROJECTION_TABLE}`

  public paramsProyeccionesOdometro: Array<params> = [
    { id: 'equipmentId', value: '0' },
    { id: 'limit', value: this.rango },
  ];

  public filteredList: Array<any>;

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Calendario",
      current: true
    }]

  constructor(
    private http: HttpService,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void {
    this.combos()
  }

  async combos() {
    let res: Array<Equipment> = await this.http.getDataBody(
      `${this.urlComboEquipos}`,
      []
    );
    if (res) {
      res.unshift({ id: 0, code: 'Todos' });
      this.comboEquipos = res;
      this.filteredList = this.comboEquipos.slice();
    }

  }

  selectTab($event: MatTabChangeEvent) {
    switch ($event.index) {
      case 0:
        break;
      case 1:
        //this.paramsProyeccionesOdometro = [{id: 'id_compania', value: this.storage.get<number>('id_compania')},{id:'id_equipo', valur:'0'},{id:'limite', value:'200'}]
        this.recargarTablaProyeccionesOdometro.emit();
        break;
      default:
        break;
    }
  }

  selectEquipo($event: MatSelectChange) {
    this.paramsProyeccionesOdometro[0].value = $event.value
    this.recargarTablaProyeccionesOdometro.emit();
  }

  changeRango() {
    this.paramsProyeccionesOdometro[1].value = this.rango
    this.recargarTablaProyeccionesOdometro.emit()
  }

  clickFilaProjection($event:Projection) {
    let size = 80
    if (screen.width < 400 || screen.height < 400) {
      size = 85
    }

    let calendarEvent: CalendarEvent = {
      title:"",
      start:null,
      id: $event.activityId
    }
    this.dialog.open(ModalCalendarComponent, {
      data: calendarEvent,
      width: `${size}vw`,
      height: `${size}vh`
    })


  }
}
